// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2yTyD","footer":"styles_footer__1AjSd","passCodeTooltip":"styles_passCodeTooltip__3nPac"};